import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type CompiledWarning = {
  __typename?: 'CompiledWarning';
  message: Scalars['String'];
  severity: Scalars['String'];
};

export type Contract = {
  __typename?: 'Contract';
  abi: Scalars['JSON'];
  compilerVersion: Scalars['String'];
  constructorArgumentsBytecode?: Maybe<Scalars['String']>;
  evmVersion: Scalars['String'];
  name: Scalars['String'];
  optimizer: Optimizer;
  sources: Array<Source>;
  status: VerificationStatus;
};

export type Erc20Token = {
  __typename?: 'Erc20Token';
  abi_l1?: Maybe<Scalars['String']>;
  abi_l2?: Maybe<Scalars['String']>;
  contract_address_l1?: Maybe<Scalars['String']>;
  contract_address_l2: Scalars['String'];
  decimals_l1?: Maybe<Scalars['Int']>;
  decimals_l2: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  type: TokenType;
};

export type Erc20TokenContractAddress = {
  __typename?: 'Erc20TokenContractAddress';
  contract_address_l1?: Maybe<Scalars['String']>;
  contract_address_l2?: Maybe<Scalars['String']>;
  symbol: Scalars['String'];
  type: TokenType;
};

export type Erc20TokenInput = {
  contractAddressL2: Scalars['String'];
};

export type Erc20TokensInput = {
  limit?: Scalars['Int'];
  next?: Scalars['String'];
  previous?: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};

export type Erc20TokensResponse = {
  __typename?: 'Erc20TokensResponse';
  data: Array<Erc20Token>;
  paginationContext: PaginationContext;
};

export type Log = {
  __typename?: 'Log';
  address: Scalars['String'];
  data: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  topics: Array<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  verifyContractWithSolidityFiles?: Maybe<CompiledWarning>;
  verifyContractWithStandardJson?: Maybe<CompiledWarning>;
  verifyInvisibleRecaptchaToken: Recaptcha;
};


export type MutationVerifyContractWithSolidityFilesArgs = {
  input: VerifyContractWithSolidityFilesInput;
};


export type MutationVerifyContractWithStandardJsonArgs = {
  input: VerifyContractWithStandardJsonInput;
};


export type MutationVerifyInvisibleRecaptchaTokenArgs = {
  token: Scalars['String'];
};

export type Optimizer = {
  __typename?: 'Optimizer';
  enabled: Scalars['Boolean'];
  runs: Scalars['Int'];
};

export type OverviewData = {
  __typename?: 'OverviewData';
  ethPriceBtc: Scalars['Float'];
  ethPriceChangePercentage24h: Scalars['Float'];
  ethPriceUsd: Scalars['Float'];
  zrcPriceBtc: Scalars['Float'];
  zrcPriceChangePercentage24h: Scalars['Float'];
  zrcPriceUsd: Scalars['Float'];
};

export type PaginationContext = {
  __typename?: 'PaginationContext';
  limit: Scalars['Int'];
  next: Scalars['String'];
  previous: Scalars['String'];
};

export type PricedToken = {
  __typename?: 'PricedToken';
  address: Scalars['String'];
  name: Scalars['String'];
  sourceAddress?: Maybe<Scalars['String']>;
  symbol: Scalars['String'];
};

export type PricedTokenInput = {
  contractAddressL2: Scalars['String'];
};

export type PricedTokensInput = {
  limit?: Scalars['Int'];
  next?: Scalars['String'];
  previous?: Scalars['String'];
  searchValue: Scalars['String'];
};

export type PricedTokensResponse = {
  __typename?: 'PricedTokensResponse';
  data: Array<PricedToken>;
  paginationContext: PaginationContext;
};

export type Query = {
  __typename?: 'Query';
  allTokens: Erc20TokensResponse;
  erc20Token?: Maybe<Erc20Token>;
  erc20TokenContractAddresses: Array<Erc20TokenContractAddress>;
  overview: OverviewData;
  pricedToken?: Maybe<PricedToken>;
  pricedTokens: PricedTokensResponse;
  tokenHoldings: TokenHoldingsResponse;
  transactionLogs: Transaction;
  verifiedContract?: Maybe<Contract>;
};


export type QueryAllTokensArgs = {
  input: Erc20TokensInput;
};


export type QueryErc20TokenArgs = {
  input: Erc20TokenInput;
};


export type QueryPricedTokenArgs = {
  input: PricedTokenInput;
};


export type QueryPricedTokensArgs = {
  input: PricedTokensInput;
};


export type QueryTokenHoldingsArgs = {
  input: TokenHoldingsInput;
};


export type QueryTransactionLogsArgs = {
  txnHash: Scalars['String'];
};


export type QueryVerifiedContractArgs = {
  hash: Scalars['String'];
};

export type Recaptcha = {
  __typename?: 'Recaptcha';
  isSuccess: Scalars['Boolean'];
};

export type Source = {
  __typename?: 'Source';
  content: Scalars['String'];
  name: Scalars['String'];
};

export type TokenHolding = {
  __typename?: 'TokenHolding';
  address: Scalars['String'];
  holding: Scalars['String'];
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price_usd?: Maybe<Scalars['String']>;
  symbol: Scalars['String'];
};

export type TokenHoldingsInput = {
  address: Scalars['String'];
};

export type TokenHoldingsResponse = {
  __typename?: 'TokenHoldingsResponse';
  data: Array<TokenHolding>;
};

export enum TokenType {
  External = 'External',
  Hidden = 'Hidden',
  NonBridgeable = 'NonBridgeable',
  Standard = 'Standard'
}

export type Transaction = {
  __typename?: 'Transaction';
  logs: Array<Log>;
};

export enum VerificationStatus {
  Full = 'Full',
  Partial = 'Partial'
}

export type VerifyContractWithSolidityFilesInput = {
  abiEncodedConstructorArguments?: InputMaybe<Scalars['String']>;
  chosenFileName: Scalars['String'];
  contractAddress: Scalars['String'];
  creatorTxHash?: InputMaybe<Scalars['String']>;
  sources: Scalars['JSON'];
  version: Scalars['String'];
};

export type VerifyContractWithStandardJsonInput = {
  abiEncodedConstructorArguments?: InputMaybe<Scalars['String']>;
  chosenFileName: Scalars['String'];
  contractAddress: Scalars['String'];
  contractJson: Scalars['String'];
  creatorTxHash?: InputMaybe<Scalars['String']>;
  version: Scalars['String'];
};

export type VerifiedContractQueryVariables = Exact<{
  hash: Scalars['String'];
}>;


export type VerifiedContractQuery = { __typename?: 'Query', verifiedContract?: { __typename?: 'Contract', name: string, compilerVersion: string, evmVersion: string, abi: any, constructorArgumentsBytecode?: string | null, status: VerificationStatus, optimizer: { __typename?: 'Optimizer', enabled: boolean, runs: number }, sources: Array<{ __typename?: 'Source', content: string, name: string }> } | null };

export type VerifyContractWithStandardJsonMutationVariables = Exact<{
  input: VerifyContractWithStandardJsonInput;
}>;


export type VerifyContractWithStandardJsonMutation = { __typename?: 'Mutation', verifyContractWithStandardJson?: { __typename?: 'CompiledWarning', message: string, severity: string } | null };

export type VerifyContractWithSolidityFilesMutationVariables = Exact<{
  input: VerifyContractWithSolidityFilesInput;
}>;


export type VerifyContractWithSolidityFilesMutation = { __typename?: 'Mutation', verifyContractWithSolidityFiles?: { __typename?: 'CompiledWarning', message: string, severity: string } | null };

export type Erc20TokenQueryVariables = Exact<{
  input: Erc20TokenInput;
}>;


export type Erc20TokenQuery = { __typename?: 'Query', erc20Token?: { __typename?: 'Erc20Token', id: number, symbol: string, name: string, contract_address_l1?: string | null, contract_address_l2: string, type: TokenType } | null };

export type AllTokensQueryVariables = Exact<{
  input: Erc20TokensInput;
}>;


export type AllTokensQuery = { __typename?: 'Query', allTokens: { __typename?: 'Erc20TokensResponse', data: Array<{ __typename?: 'Erc20Token', id: number, name: string, symbol: string, contract_address_l1?: string | null, contract_address_l2: string, decimals_l1?: number | null, decimals_l2: number, type: TokenType }>, paginationContext: { __typename?: 'PaginationContext', limit: number, next: string, previous: string } } };

export type Erc20TokenContractAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type Erc20TokenContractAddressesQuery = { __typename?: 'Query', erc20TokenContractAddresses: Array<{ __typename?: 'Erc20TokenContractAddress', contract_address_l1?: string | null, contract_address_l2?: string | null, type: TokenType, symbol: string }> };

export type OverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type OverviewQuery = { __typename?: 'Query', overview: { __typename?: 'OverviewData', ethPriceUsd: number, ethPriceBtc: number, ethPriceChangePercentage24h: number, zrcPriceUsd: number, zrcPriceBtc: number, zrcPriceChangePercentage24h: number } };

export type PricedTokensQueryVariables = Exact<{
  input: PricedTokensInput;
}>;


export type PricedTokensQuery = { __typename?: 'Query', pricedTokens: { __typename?: 'PricedTokensResponse', data: Array<{ __typename?: 'PricedToken', address: string, sourceAddress?: string | null, name: string, symbol: string }>, paginationContext: { __typename?: 'PaginationContext', limit: number, next: string, previous: string } } };

export type PricedTokenQueryVariables = Exact<{
  input: PricedTokenInput;
}>;


export type PricedTokenQuery = { __typename?: 'Query', pricedToken?: { __typename?: 'PricedToken', address: string, sourceAddress?: string | null, name: string, symbol: string } | null };

export type VerifyInvisibleRecaptchaTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyInvisibleRecaptchaTokenMutation = { __typename?: 'Mutation', verifyInvisibleRecaptchaToken: { __typename?: 'Recaptcha', isSuccess: boolean } };

export type TokenHoldingsQueryVariables = Exact<{
  input: TokenHoldingsInput;
}>;


export type TokenHoldingsQuery = { __typename?: 'Query', tokenHoldings: { __typename?: 'TokenHoldingsResponse', data: Array<{ __typename?: 'TokenHolding', address: string, image_url?: string | null, symbol: string, name: string, holding: string, price_usd?: string | null }> } };

export type TransactionLogsQueryVariables = Exact<{
  txnHash: Scalars['String'];
}>;


export type TransactionLogsQuery = { __typename?: 'Query', transactionLogs: { __typename?: 'Transaction', logs: Array<{ __typename?: 'Log', address: string, name?: string | null, topics: Array<string>, data: string }> } };


export const VerifiedContractDocument = gql`
    query VerifiedContract($hash: String!) {
  verifiedContract(hash: $hash) {
    name
    compilerVersion
    evmVersion
    optimizer {
      enabled
      runs
    }
    sources {
      content
      name
    }
    abi
    constructorArgumentsBytecode
    status
  }
}
    `;

/**
 * __useVerifiedContractQuery__
 *
 * To run a query within a React component, call `useVerifiedContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifiedContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifiedContractQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useVerifiedContractQuery(baseOptions: Apollo.QueryHookOptions<VerifiedContractQuery, VerifiedContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifiedContractQuery, VerifiedContractQueryVariables>(VerifiedContractDocument, options);
      }
export function useVerifiedContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifiedContractQuery, VerifiedContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifiedContractQuery, VerifiedContractQueryVariables>(VerifiedContractDocument, options);
        }
export type VerifiedContractQueryHookResult = ReturnType<typeof useVerifiedContractQuery>;
export type VerifiedContractLazyQueryHookResult = ReturnType<typeof useVerifiedContractLazyQuery>;
export type VerifiedContractQueryResult = Apollo.QueryResult<VerifiedContractQuery, VerifiedContractQueryVariables>;
export const VerifyContractWithStandardJsonDocument = gql`
    mutation VerifyContractWithStandardJson($input: VerifyContractWithStandardJsonInput!) {
  verifyContractWithStandardJson(input: $input) {
    message
    severity
  }
}
    `;
export type VerifyContractWithStandardJsonMutationFn = Apollo.MutationFunction<VerifyContractWithStandardJsonMutation, VerifyContractWithStandardJsonMutationVariables>;

/**
 * __useVerifyContractWithStandardJsonMutation__
 *
 * To run a mutation, you first call `useVerifyContractWithStandardJsonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyContractWithStandardJsonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyContractWithStandardJsonMutation, { data, loading, error }] = useVerifyContractWithStandardJsonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyContractWithStandardJsonMutation(baseOptions?: Apollo.MutationHookOptions<VerifyContractWithStandardJsonMutation, VerifyContractWithStandardJsonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyContractWithStandardJsonMutation, VerifyContractWithStandardJsonMutationVariables>(VerifyContractWithStandardJsonDocument, options);
      }
export type VerifyContractWithStandardJsonMutationHookResult = ReturnType<typeof useVerifyContractWithStandardJsonMutation>;
export type VerifyContractWithStandardJsonMutationResult = Apollo.MutationResult<VerifyContractWithStandardJsonMutation>;
export type VerifyContractWithStandardJsonMutationOptions = Apollo.BaseMutationOptions<VerifyContractWithStandardJsonMutation, VerifyContractWithStandardJsonMutationVariables>;
export const VerifyContractWithSolidityFilesDocument = gql`
    mutation VerifyContractWithSolidityFiles($input: VerifyContractWithSolidityFilesInput!) {
  verifyContractWithSolidityFiles(input: $input) {
    message
    severity
  }
}
    `;
export type VerifyContractWithSolidityFilesMutationFn = Apollo.MutationFunction<VerifyContractWithSolidityFilesMutation, VerifyContractWithSolidityFilesMutationVariables>;

/**
 * __useVerifyContractWithSolidityFilesMutation__
 *
 * To run a mutation, you first call `useVerifyContractWithSolidityFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyContractWithSolidityFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyContractWithSolidityFilesMutation, { data, loading, error }] = useVerifyContractWithSolidityFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyContractWithSolidityFilesMutation(baseOptions?: Apollo.MutationHookOptions<VerifyContractWithSolidityFilesMutation, VerifyContractWithSolidityFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyContractWithSolidityFilesMutation, VerifyContractWithSolidityFilesMutationVariables>(VerifyContractWithSolidityFilesDocument, options);
      }
export type VerifyContractWithSolidityFilesMutationHookResult = ReturnType<typeof useVerifyContractWithSolidityFilesMutation>;
export type VerifyContractWithSolidityFilesMutationResult = Apollo.MutationResult<VerifyContractWithSolidityFilesMutation>;
export type VerifyContractWithSolidityFilesMutationOptions = Apollo.BaseMutationOptions<VerifyContractWithSolidityFilesMutation, VerifyContractWithSolidityFilesMutationVariables>;
export const Erc20TokenDocument = gql`
    query Erc20Token($input: Erc20TokenInput!) {
  erc20Token(input: $input) {
    id
    symbol
    name
    contract_address_l1
    contract_address_l2
    type
  }
}
    `;

/**
 * __useErc20TokenQuery__
 *
 * To run a query within a React component, call `useErc20TokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useErc20TokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErc20TokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErc20TokenQuery(baseOptions: Apollo.QueryHookOptions<Erc20TokenQuery, Erc20TokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Erc20TokenQuery, Erc20TokenQueryVariables>(Erc20TokenDocument, options);
      }
export function useErc20TokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Erc20TokenQuery, Erc20TokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Erc20TokenQuery, Erc20TokenQueryVariables>(Erc20TokenDocument, options);
        }
export type Erc20TokenQueryHookResult = ReturnType<typeof useErc20TokenQuery>;
export type Erc20TokenLazyQueryHookResult = ReturnType<typeof useErc20TokenLazyQuery>;
export type Erc20TokenQueryResult = Apollo.QueryResult<Erc20TokenQuery, Erc20TokenQueryVariables>;
export const AllTokensDocument = gql`
    query AllTokens($input: Erc20TokensInput!) {
  allTokens(input: $input) {
    data {
      id
      name
      symbol
      contract_address_l1
      contract_address_l2
      decimals_l1
      decimals_l2
      type
    }
    paginationContext {
      limit
      next
      previous
    }
  }
}
    `;

/**
 * __useAllTokensQuery__
 *
 * To run a query within a React component, call `useAllTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTokensQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllTokensQuery(baseOptions: Apollo.QueryHookOptions<AllTokensQuery, AllTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTokensQuery, AllTokensQueryVariables>(AllTokensDocument, options);
      }
export function useAllTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTokensQuery, AllTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTokensQuery, AllTokensQueryVariables>(AllTokensDocument, options);
        }
export type AllTokensQueryHookResult = ReturnType<typeof useAllTokensQuery>;
export type AllTokensLazyQueryHookResult = ReturnType<typeof useAllTokensLazyQuery>;
export type AllTokensQueryResult = Apollo.QueryResult<AllTokensQuery, AllTokensQueryVariables>;
export const Erc20TokenContractAddressesDocument = gql`
    query Erc20TokenContractAddresses {
  erc20TokenContractAddresses {
    contract_address_l1
    contract_address_l2
    type
    symbol
  }
}
    `;

/**
 * __useErc20TokenContractAddressesQuery__
 *
 * To run a query within a React component, call `useErc20TokenContractAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useErc20TokenContractAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErc20TokenContractAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useErc20TokenContractAddressesQuery(baseOptions?: Apollo.QueryHookOptions<Erc20TokenContractAddressesQuery, Erc20TokenContractAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Erc20TokenContractAddressesQuery, Erc20TokenContractAddressesQueryVariables>(Erc20TokenContractAddressesDocument, options);
      }
export function useErc20TokenContractAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Erc20TokenContractAddressesQuery, Erc20TokenContractAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Erc20TokenContractAddressesQuery, Erc20TokenContractAddressesQueryVariables>(Erc20TokenContractAddressesDocument, options);
        }
export type Erc20TokenContractAddressesQueryHookResult = ReturnType<typeof useErc20TokenContractAddressesQuery>;
export type Erc20TokenContractAddressesLazyQueryHookResult = ReturnType<typeof useErc20TokenContractAddressesLazyQuery>;
export type Erc20TokenContractAddressesQueryResult = Apollo.QueryResult<Erc20TokenContractAddressesQuery, Erc20TokenContractAddressesQueryVariables>;
export const OverviewDocument = gql`
    query Overview {
  overview {
    ethPriceUsd
    ethPriceBtc
    ethPriceChangePercentage24h
    zrcPriceUsd
    zrcPriceBtc
    zrcPriceChangePercentage24h
  }
}
    `;

/**
 * __useOverviewQuery__
 *
 * To run a query within a React component, call `useOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useOverviewQuery(baseOptions?: Apollo.QueryHookOptions<OverviewQuery, OverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewQuery, OverviewQueryVariables>(OverviewDocument, options);
      }
export function useOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewQuery, OverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewQuery, OverviewQueryVariables>(OverviewDocument, options);
        }
export type OverviewQueryHookResult = ReturnType<typeof useOverviewQuery>;
export type OverviewLazyQueryHookResult = ReturnType<typeof useOverviewLazyQuery>;
export type OverviewQueryResult = Apollo.QueryResult<OverviewQuery, OverviewQueryVariables>;
export const PricedTokensDocument = gql`
    query PricedTokens($input: PricedTokensInput!) {
  pricedTokens(input: $input) {
    data {
      address
      sourceAddress
      name
      symbol
    }
    paginationContext {
      limit
      next
      previous
    }
  }
}
    `;

/**
 * __usePricedTokensQuery__
 *
 * To run a query within a React component, call `usePricedTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricedTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricedTokensQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePricedTokensQuery(baseOptions: Apollo.QueryHookOptions<PricedTokensQuery, PricedTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricedTokensQuery, PricedTokensQueryVariables>(PricedTokensDocument, options);
      }
export function usePricedTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricedTokensQuery, PricedTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricedTokensQuery, PricedTokensQueryVariables>(PricedTokensDocument, options);
        }
export type PricedTokensQueryHookResult = ReturnType<typeof usePricedTokensQuery>;
export type PricedTokensLazyQueryHookResult = ReturnType<typeof usePricedTokensLazyQuery>;
export type PricedTokensQueryResult = Apollo.QueryResult<PricedTokensQuery, PricedTokensQueryVariables>;
export const PricedTokenDocument = gql`
    query PricedToken($input: PricedTokenInput!) {
  pricedToken(input: $input) {
    address
    sourceAddress
    name
    symbol
  }
}
    `;

/**
 * __usePricedTokenQuery__
 *
 * To run a query within a React component, call `usePricedTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricedTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricedTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePricedTokenQuery(baseOptions: Apollo.QueryHookOptions<PricedTokenQuery, PricedTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricedTokenQuery, PricedTokenQueryVariables>(PricedTokenDocument, options);
      }
export function usePricedTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricedTokenQuery, PricedTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricedTokenQuery, PricedTokenQueryVariables>(PricedTokenDocument, options);
        }
export type PricedTokenQueryHookResult = ReturnType<typeof usePricedTokenQuery>;
export type PricedTokenLazyQueryHookResult = ReturnType<typeof usePricedTokenLazyQuery>;
export type PricedTokenQueryResult = Apollo.QueryResult<PricedTokenQuery, PricedTokenQueryVariables>;
export const VerifyInvisibleRecaptchaTokenDocument = gql`
    mutation VerifyInvisibleRecaptchaToken($token: String!) {
  verifyInvisibleRecaptchaToken(token: $token) {
    isSuccess
  }
}
    `;
export type VerifyInvisibleRecaptchaTokenMutationFn = Apollo.MutationFunction<VerifyInvisibleRecaptchaTokenMutation, VerifyInvisibleRecaptchaTokenMutationVariables>;

/**
 * __useVerifyInvisibleRecaptchaTokenMutation__
 *
 * To run a mutation, you first call `useVerifyInvisibleRecaptchaTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyInvisibleRecaptchaTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyInvisibleRecaptchaTokenMutation, { data, loading, error }] = useVerifyInvisibleRecaptchaTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyInvisibleRecaptchaTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyInvisibleRecaptchaTokenMutation, VerifyInvisibleRecaptchaTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyInvisibleRecaptchaTokenMutation, VerifyInvisibleRecaptchaTokenMutationVariables>(VerifyInvisibleRecaptchaTokenDocument, options);
      }
export type VerifyInvisibleRecaptchaTokenMutationHookResult = ReturnType<typeof useVerifyInvisibleRecaptchaTokenMutation>;
export type VerifyInvisibleRecaptchaTokenMutationResult = Apollo.MutationResult<VerifyInvisibleRecaptchaTokenMutation>;
export type VerifyInvisibleRecaptchaTokenMutationOptions = Apollo.BaseMutationOptions<VerifyInvisibleRecaptchaTokenMutation, VerifyInvisibleRecaptchaTokenMutationVariables>;
export const TokenHoldingsDocument = gql`
    query TokenHoldings($input: TokenHoldingsInput!) {
  tokenHoldings(input: $input) {
    data {
      address
      image_url
      symbol
      name
      holding
      price_usd
    }
  }
}
    `;

/**
 * __useTokenHoldingsQuery__
 *
 * To run a query within a React component, call `useTokenHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTokenHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTokenHoldingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTokenHoldingsQuery(baseOptions: Apollo.QueryHookOptions<TokenHoldingsQuery, TokenHoldingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TokenHoldingsQuery, TokenHoldingsQueryVariables>(TokenHoldingsDocument, options);
      }
export function useTokenHoldingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TokenHoldingsQuery, TokenHoldingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TokenHoldingsQuery, TokenHoldingsQueryVariables>(TokenHoldingsDocument, options);
        }
export type TokenHoldingsQueryHookResult = ReturnType<typeof useTokenHoldingsQuery>;
export type TokenHoldingsLazyQueryHookResult = ReturnType<typeof useTokenHoldingsLazyQuery>;
export type TokenHoldingsQueryResult = Apollo.QueryResult<TokenHoldingsQuery, TokenHoldingsQueryVariables>;
export const TransactionLogsDocument = gql`
    query TransactionLogs($txnHash: String!) {
  transactionLogs(txnHash: $txnHash) {
    logs {
      address
      name
      topics
      data
    }
  }
}
    `;

/**
 * __useTransactionLogsQuery__
 *
 * To run a query within a React component, call `useTransactionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionLogsQuery({
 *   variables: {
 *      txnHash: // value for 'txnHash'
 *   },
 * });
 */
export function useTransactionLogsQuery(baseOptions: Apollo.QueryHookOptions<TransactionLogsQuery, TransactionLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionLogsQuery, TransactionLogsQueryVariables>(TransactionLogsDocument, options);
      }
export function useTransactionLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionLogsQuery, TransactionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionLogsQuery, TransactionLogsQueryVariables>(TransactionLogsDocument, options);
        }
export type TransactionLogsQueryHookResult = ReturnType<typeof useTransactionLogsQuery>;
export type TransactionLogsLazyQueryHookResult = ReturnType<typeof useTransactionLogsLazyQuery>;
export type TransactionLogsQueryResult = Apollo.QueryResult<TransactionLogsQuery, TransactionLogsQueryVariables>;